module.exports = __webpack_public_path__ + "img/life_at_ftcash_intro_bg.e7d02fce.jpg";